import {
  getMyOrganization,
  getOrganizationMembers,
} from "@/lib/organization/api";
import { Organization, User } from "@/types";
import { useSuspenseQuery } from "@tanstack/react-query";

export function useGetMyOrganization() {
  return useSuspenseQuery({
    queryKey: ["organizations"],
    queryFn: async () => {
      try {
        return await getMyOrganization();
      } catch (error) {
        console.error("Failed to fetch organization:", error);
        return { data: {} };
      }
    },
    select: (data) => {
      try {
        return (data?.data || {}) as Organization;
      } catch (error) {
        console.error("Error in organization select:", error);
        return {} as Organization;
      }
    },
  });
}

export function useGetOrganizationMembers() {
  return useSuspenseQuery({
    queryKey: ["organizationMembers"],
    queryFn: async () => {
      try {
        return await getOrganizationMembers();
      } catch (error) {
        console.error("Failed to fetch organization members:", error);
        return { data: { items: [] } };
      }
    },
    select: (data) => {
      try {
        if (data?.data?.items) {
          return data.data.items as User[];
        }
        if (Array.isArray(data?.data)) {
          return data.data as User[];
        }
        return [] as User[];
      } catch (error) {
        console.error("Error in organization members select:", error);
        return [] as User[];
      }
    },
  });
}
